import { takeLatest, put, call, delay } from 'redux-saga/effects';
import { axiosInstance } from '../../utils';

import {
  CREATE_CONTACT_ADD_TO_LIST, MODAL_CLOSE, CREATE_CONTACT_ADD_TO_LIST_SUCCESS, CREATE_CONTACT_ADD_TO_LIST_FAILURE, CLEAR_ACTIVECAMPAIGN,
  CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER, CREATE_CONTACT_ADD_TO_LIST_SUCCESS_FROM_FOOTER, CREATE_CONTACT_ADD_TO_LIST_FAILURE_FROM_FOOTER
} from "../types";

function* createContactAddToListSaga({ payload }) {
  const {
    name,
    email
  } = payload;
  try {
    const response = yield call(axiosInstance.post, 'activecampaign/createContactAddToList', { name, email });
    if (response) {
      yield put({ type: CREATE_CONTACT_ADD_TO_LIST_SUCCESS, message: "success" });
      yield delay(5000);
      yield put({ type: MODAL_CLOSE });
      yield put({ type: CLEAR_ACTIVECAMPAIGN });
    }
  } catch (error) {
    var err = ""
    if( Array.isArray(error.error) ){ 
      err = error.error[0]
    }
    if (err.hasOwnProperty('title')){
      yield put({ type: CREATE_CONTACT_ADD_TO_LIST_FAILURE, error: err });
    }
    else{
      yield put({ type: CREATE_CONTACT_ADD_TO_LIST_SUCCESS, message: "success" });
      yield delay(10000);
      yield put({ type: CLEAR_ACTIVECAMPAIGN });
    }
  }
}

function* createContactAddToListSagaFromFooter({ payload }) {
  const {
    name,
    email
  } = payload;
  try {
    const response = yield call(axiosInstance.post, 'activecampaign/createContactAddToList', { name, email });
    if (response) {
      yield put({ type: CREATE_CONTACT_ADD_TO_LIST_SUCCESS_FROM_FOOTER, message: "success" });
      yield delay(10000);
      yield put({ type: CLEAR_ACTIVECAMPAIGN });
    }
  } catch (error) {
    var err = ""
    if( Array.isArray(error.error) ){ 
      err = error.error[0]
    }
    if (err.hasOwnProperty('title')){
      yield put({ type: CREATE_CONTACT_ADD_TO_LIST_FAILURE_FROM_FOOTER, error: err });
    }
    else{
      yield put({ type: CREATE_CONTACT_ADD_TO_LIST_SUCCESS_FROM_FOOTER, message: "success" });
      yield delay(10000);
      yield put({ type: CLEAR_ACTIVECAMPAIGN });
    }
  }
}

export default function* saga() {
  yield takeLatest(CREATE_CONTACT_ADD_TO_LIST, createContactAddToListSaga);
  yield takeLatest(CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER, createContactAddToListSagaFromFooter)
}
